var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DareContextProvider } from 'root/src/client/web/list/listItemComponents/dare/contexts/dare';
import { DareCard } from 'root/src/client/web/list/listItemComponents/dare/DareCard';
import getBountyName from 'root/src/shared/util/getBountyName';
import { isDropComingSoon } from 'root/src/shared/drops/helpers/isDropComingSoon.helper';
import { useAcceptDare } from 'root/src/client/v2/drop/hooks/useAcceptDare';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { useBattlePassActiveCreatorTier, useBattlePassDetails, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
import { toast } from 'react-hot-toast';
import { useIsAdmin } from 'root/src/client/v2/auth/hooks/useIsAdmin';
import { useIsBrand } from 'root/src/client/v2/auth/hooks/useIsBrand';
import { COMING_SOON_MASK_TEXT } from 'root/src/shared/constants/dropEvent';
import { useEmailSubscribeMutation } from 'root/src/client/v2/drop/hooks/useEmailSubscribeMutation';
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi';
export const DareCardBattlePass = ({ dare, drop }) => {
    const dareProvider = useDareCardBattlePassContextProvider({ drop, dare });
    return (<DareContextProvider value={dareProvider}>
			<DareCard className="animate-[slide-up_.4s]"/>
		</DareContextProvider>);
};
const useDareCardBattlePassContextProvider = ({ drop, dare }) => {
    var _a;
    const battlePassDetails = useBattlePassDetails();
    const { isAdmin } = useIsAdmin();
    const { isBrand } = useIsBrand();
    const { onAcceptDare } = useAcceptDare({ drop, dare });
    const isLockedByTier = useIsLockedByTier(dare.battlePass);
    const isComingSoon = isDropComingSoon(drop);
    const emailSubscribeMutation = useEmailSubscribeMutation();
    const brandProductName = isComingSoon
        ? COMING_SOON_MASK_TEXT : getBountyName({
        name: dare.product.name,
        type: dare.product.type,
        region: dare.product.region,
        platform: dare.product.platform,
    }, true);
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        const onSuccess = (project) => __awaiter(void 0, void 0, void 0, function* () {
            if (project) {
                yield battlePassDetails.refetch();
                toast.success('Dare successfully accepted!');
            }
        });
        yield onAcceptDare({ onSuccess });
    });
    const onEmailSubscribe = () => __awaiter(void 0, void 0, void 0, function* () {
        if (drop.isEmailSubscribed) {
            return;
        }
        try {
            yield emailSubscribeMutation.mutateAsync(drop.id);
            void battlePassDetails.refetch();
            toast.success(`We'll notify you when ${drop.campaignName} goes live!`);
        }
        catch (err) {
            const message = getErrorMessage(err);
            toast.error(message);
        }
    });
    return {
        drop,
        isLockedByTier,
        isAbleToParticipate: drop.isAbleToParticipate,
        comingSoon: isDropComingSoon(drop),
        canAccessCreateBrandProject: isAdmin || isBrand,
        brandProduct: { brandProductName },
        projectAccepted: dare.status === ProjectStatus.ProjectAccepted,
        projectCompleted: Number((_a = dare.deliveries) === null || _a === void 0 ? void 0 : _a.length) > 0,
        projectDeliveryPending: dare.isDeliveryPending,
        projectStatus: dare.status,
        onClick,
        brand: drop.brand,
        dare,
        onEmailSubscribe,
        emailSubscription: drop.isEmailSubscribed,
    };
};
const useIsLockedByTier = (battlePass) => {
    const { creatorTier } = useBattlePassActiveCreatorTier();
    return battlePass.tier - 1 > creatorTier;
};
